"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * One measurement's own miniature: its span, with each mark where it fell.
 *
 * Drawn against the slowest measurement in the whole window rather than the
 * page, so a trace means the same thing on either side of a page break.
 */
const styles = exports.styles = {
  trace: {
    position: "x1n2onr6",
    height: "xvle69y",
    minWidth: "xzhy1st",
    width: "xh8yej3",
    $$css: true
  },
  traceSpan: {
    position: "x10l6tqk",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    top: "x1ghao90",
    height: "x36qwtl",
    backgroundColor: "xlunp35",
    $$css: true
  },
  traceMark: {
    position: "x10l6tqk",
    top: "x13vifvy",
    width: "xfo62xy",
    height: "xvle69y",
    backgroundColor: "x1c1r1s3",
    $$css: true
  }
};